import React from 'react';

const AuthLayout = ({ title, subtitle, children, branding = null }) => {
  // Use agency branding if provided, otherwise use default
  const primaryColor = branding?.theme?.primary || '#3B82F6';
  const secondaryColor = branding?.theme?.secondary || '#10B981';
  const agencyName = branding?.agencyName || 'LiveLoveSpain';
  const agencyMotto = branding?.agencyMotto || 'Your Relocation Partner';
  const logoUrl = branding?.agencyLogo || branding?.logoUrl || '/LiveLoveSpain.png';
  
  // Generate gradient background from branding colors
  const gradientFrom = `from-[${primaryColor}]20`;
  const gradientVia = 'via-white';
  const gradientTo = `to-[${secondaryColor}]20`;
  
  return (
    <div 
      className="min-h-screen relative flex flex-col justify-center bg-gradient-to-br from-blue-50 via-white to-rose-50 py-12 sm:px-6 lg:px-8"
      style={{
        background: `linear-gradient(to bottom right, ${primaryColor}15, white, ${secondaryColor}15)`
      }}
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
        <div 
          className="absolute -top-40 -right-32 w-96 h-96 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"
          style={{ backgroundColor: `${primaryColor}40` }}
        ></div>
        <div 
          className="absolute -bottom-40 -left-32 w-96 h-96 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"
          style={{ backgroundColor: `${secondaryColor}40` }}
        ></div>
      </div>
      <div className="relative sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center mb-6">
          <img 
            src={logoUrl} 
            alt={`${agencyName} Logo`} 
            className="mx-auto h-10 mb-3" 
            onError={(e) => {
              // Fallback to default logo if image fails to load
              e.target.src = '/LiveLoveSpain.png';
            }}
          />
          <h1 
            className="text-4xl font-bold bg-clip-text text-transparent mb-2"
            style={{
              background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}
          >
            {title}
          </h1>
          {subtitle && <p className="text-gray-600">{subtitle}</p>}
          {branding && agencyMotto && (
            <p className="text-sm text-gray-500 mt-1">{agencyMotto}</p>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;







